import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import './Calendar.css';

function CalendarComponent() {
  const calendarRef = useRef(); 
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Sample events (shifts)
  const events = [
    {
      title: 'Dr. Smith - Morning',
      start: '2025-05-01',
      backgroundColor: '#e6f7ff',
      borderColor: '#1890ff'
    },
    {
      title: 'Dr. Jones - Evening',
      start: '2025-05-02',
      backgroundColor: '#fff7e6',
      borderColor: '#fa8c16'
    },
    {
      title: 'Dr. Brown - Night',
      start: '2025-05-02',
      backgroundColor: '#f9f0ff',
      borderColor: '#722ed1'
    },
    // Add more events as needed
  ];
  
  const handleDateClick = (info) => {
    alert('Clicked on: ' + info.dateStr);
    // You can add more functionality here
  };
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      const calendarApi = calendarRef.current?.getApi();
      calendarApi?.updateSize();
      //calendarApi?.changeView(calendarApi.view.type); //Force re-render of day headers
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="calendar-container">
      <FullCalendar
        ref={calendarRef} // Add this prop to FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next',
          center: 'title',
          right: 'today dayGridMonth,timeGridWeek'
        }}
        events={events}
        dateClick={handleDateClick}
        height="100%" // Change from "auto" to "100%"
        aspectRatio={1.35} // Slightly adjusted for better proportions
        stickyHeaderDates={true} // Keep headers visible when scrolling
        dayMaxEvents={true} // Allow "more" link when too many events
        expandRows={true} // Make sure the rows expand to use available height  
        dayHeaderContent={(arg) => {
          return windowWidth <= 768 
            ? arg.date.toLocaleDateString(undefined, { weekday: 'short' }) 
            : arg.text;
        }}
        views={{
          dayGridMonth: {
            dayHeaderFormat: windowWidth <= 768 
              ? { weekday: 'short' } 
              : { weekday: 'long' }
          },
          timeGridWeek: {
            dayHeaderFormat: windowWidth <= 768 
              ? { weekday: 'short' } 
              : { weekday: 'long' }
          }
        }}
      />
    </div>
  );
}

export default CalendarComponent;
